import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectSeparator,
} from '@/components/ui/select';
import { Calendar } from 'lucide-react';
import { cn } from '@/lib/utils';
import { TimeRange } from '@/types/filters';

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
  className?: string;
  showCustom?: boolean;
}

const timeRangeOptions = [
  { value: 'hour' as TimeRange, label: 'Última hora' },
  { value: 'day' as TimeRange, label: 'Hoy' },
  { value: 'week' as TimeRange, label: 'Esta semana' },
  { value: 'month' as TimeRange, label: 'Este mes' },
  { value: 'quarter' as TimeRange, label: 'Este trimestre' },
  { value: 'year' as TimeRange, label: 'Este año' },
];

export const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  value,
  onChange,
  className,
  showCustom = false
}) => {
  const selectedOption = timeRangeOptions.find(option => option.value === value);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={cn("w-[180px] bg-white border-figma-primary/20 hover:border-figma-primary/40 transition-colors", className)}>
        <Calendar className="h-4 w-4 mr-2 text-figma-primary" />
        <SelectValue placeholder="Seleccionar período">
          {selectedOption?.label || 'Seleccionar período'}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-white border-figma-primary/20 shadow-figma">
        {timeRangeOptions.map(option => (
          <SelectItem 
            key={option.value} 
            value={option.value}
            className="hover:bg-figma-primary/5 focus:bg-figma-primary/10 text-figma-text-primary"
          >
            {option.label}
          </SelectItem>
        ))}
        {showCustom && (
          <>
            <SelectSeparator className="bg-figma-primary/10" />
            <SelectItem value="custom" className="hover:bg-figma-primary/5 focus:bg-figma-primary/10 text-figma-text-primary">
              Personalizado...
            </SelectItem>
          </>
        )}
      </SelectContent>
    </Select>
  );
};